//@flow

import React from 'react';
import { connect } from 'react-redux';

import {
  openLoginModal,
  loginSessionExpire,
  logout,
} from '../../redux/actions/authActions';
import { hasTokenExpired } from '../../lib/utils';

type Props = {
  openLoginModal: Function,
  loginSessionExpire: Function,
  hasSessionExpired: boolean,
  isUserLoggedIn: boolean,
};

class LoginSessionExpire extends React.Component<Props> {
  componentDidMount() {
    const { loginSessionExpire, hasSessionExpired, logout } = this.props;

    if (hasTokenExpired()) {
      if (!hasSessionExpired) logout();
    } else {
      if (hasSessionExpired) loginSessionExpire(false);
    }
  }

  render() {
    return null;
  }
}

export default connect(
  ({ user }) => ({
    hasSessionExpired: user.hasSessionExpired,
    isUserLoggedIn: Boolean(user.userId),
  }),
  {
    openLoginModal,
    loginSessionExpire,
    logout,
  }
)(LoginSessionExpire);



// WEBPACK FOOTER //
// ./src/screens/LoginSessionExpire/LoginSessionExpire.jsx